<template>
  <div class="selected-options">
    <div v-for="(variant, index) in variants" :key="index" class="selected-option">
      <component
      v-if="availableComponent[variant.attribute_code] && variant.value"
      :is="availableComponent[variant.attribute_code]"
      :option="variant" />
    </div>
  </div>
</template>

<script>

// load component custom
import ColorSelected from './SelectedOptions/ColorSelected'
import SizeSelected from './SelectedOptions/SizeSelected'

export default {
  props: {
    variants: {
      type: Array,
      required: true
    }
  },
  computed: {
    availableComponent () {
      return {
        'color': ColorSelected,
        'size': SizeSelected
      }
    }
  },
  components: {
    ColorSelected,
    SizeSelected
  }
}
</script>
